"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var User_1 = require("portal/containers/User");
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var use_react_router_1 = __importDefault(require("use-react-router"));
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
function IRTable(props) {
    var _this = this;
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var history = (0, use_react_router_1.default)().history;
    (0, useTitle_1.default)(t("common.IR"));
    var ref = collectionsRef_1.IRsRef;
    if (props.projectId) {
        ref = ref.where("projectId", "==", props.projectId);
    }
    if (props.orderId) {
        ref = ref.where("orderId", "==", props.orderId);
    }
    if (props.statuses) {
        ref = ref.where("status", "in", props.statuses);
    }
    if (props.approvedByMe) {
        ref = ref.where("status", "==", "approved");
    }
    var snapshot = (0, firestore_1.useCollection)(ref)[0];
    var _b = (0, react_1.useState)(false), createIRLoading = _b[0], setCreateIRLoading = _b[1];
    var _c = (0, firestore_1.useDocument)(collectionsRef_1.projectsRef.doc(props.projectId)), projectSN = _c[0], loading = _c[1];
    var projectsRolesSN = (0, firestore_1.useCollection)(collectionsRef_1.projectsRolesRef.where("projectId", "==", props.projectId))[0];
    var IRsSN = (0, firestore_1.useCollection)(collectionsRef_1.IRsRef)[0];
    var _d = (0, User_1.useUser)(), supabaseUser = _d.supabaseUser, userLoading = _d.loading;
    // const [ordersSn] = useDocument(ordersRef.doc(props.orderId))
    // const ordersData = ordersSn.data() as Order
    var createProjectIRPermission = (0, hasProjectPermission_1.hasProjectPermission)(props.projectId, [
        "IRCreate",
    ]);
    var projectData = projectSN === null || projectSN === void 0 ? void 0 : projectSN.data();
    var projectStatus = projectData === null || projectData === void 0 ? void 0 : projectData.status;
    var dataSource = ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (s) {
        var data = s.data();
        return __assign(__assign({}, data), { id: s.id });
    });
    if (!projectSN ||
        loading ||
        !IRsSN ||
        !projectStatus ||
        !projectsRolesSN ||
        userLoading ||
        !supabaseUser) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var columns = [
        {
            name: "projectId",
            title: t("projects.projectName"),
            getCellValue: function (r) {
                var _a;
                return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.name;
            },
        },
        {
            name: "createdAt",
            title: t("orders.createdAt"),
            getCellValue: function (r) {
                var _a;
                return t("common.fullDateTime", { date: (_a = r.createdAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: "requestedAt",
            title: t("orders.requestedAt"),
            getCellValue: function (r) {
                var _a;
                return t("common.fullDateTime", { date: (_a = r.requestedAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: "requestedBy",
            title: t("orders.requestedBy"),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.requestedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
            },
        },
        {
            name: "initiatedBy",
            title: t("orders.initiatedBy"),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.initiatedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
            },
        },
        {
            name: "status",
            title: t("orders.status"),
        },
        {
            name: "description",
            title: t("orders.description"),
        },
        {
            name: "id",
            title: t("common.actions"),
            key: "id",
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                var projectId = dataSource.find(function (e) { return e.id === row.id; }).projectId;
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["IRView"]) ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/internal-requests/".concat(row.id, "/"), type: "primary", style: { margin: "0px 5px" } }, { children: t("common.view") })) }))) : null }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [createProjectIRPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ loading: createIRLoading, type: "primary", style: {
                    position: "absolute",
                    right: "90px",
                    marginTop: 16,
                    zIndex: 999,
                }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    var IRId, IRSerials, dateOfNow, lastSerial, orderCreate;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                setCreateIRLoading(true);
                                IRId = collectionsRef_1.IRsRef.doc().id;
                                return [4 /*yield*/, collectionsRef_1.IRsRef.get()];
                            case 1:
                                IRSerials = (_a = (_c.sent()).docs) === null || _a === void 0 ? void 0 : _a.map(function (e) {
                                    var _a;
                                    return (_a = e.data()) === null || _a === void 0 ? void 0 : _a.IRNo;
                                });
                                dateOfNow = (0, moment_1.default)().format("MMYY");
                                lastSerial = (_b = (0, lodash_1.max)(IRSerials)) !== null && _b !== void 0 ? _b : 0;
                                return [4 /*yield*/, collectionsRef_1.ordersRef.add({
                                        projectId: props.projectId,
                                        status: "preparingIR",
                                        IRId: IRId,
                                        createdAt: new Date(),
                                    })];
                            case 2:
                                orderCreate = _c.sent();
                                return [4 /*yield*/, collectionsRef_1.IRsRef.doc(IRId).set({
                                        status: "draft",
                                        projectId: projectSN.id,
                                        createdAt: new Date(),
                                        initiatedBy: supabaseUser.uid,
                                        orderId: orderCreate.id,
                                        description: "",
                                        exchangeRate: 1,
                                        totalEstimatedCostInUsd: 0,
                                        totalEstimatedCostInLocalCurrency: 0,
                                        // IRNo: lastSerial + 1,
                                        // ref: `${dateOfNow}-${lastSerial + 1}`,
                                    })];
                            case 3:
                                _c.sent();
                                return [4 /*yield*/, collectionsRef_1.IRItemsRef.add({
                                        IRId: IRId,
                                        estimatedPrice: 0,
                                        quantity: 0,
                                        createdAt: new Date(),
                                    })];
                            case 4:
                                _c.sent();
                                setCreateIRLoading(false);
                                navigate("/internal-requests/".concat(IRId));
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: t("projects.createIR") }))) : null, (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                    table: "internal-requests",
                    filter: !props.orderId,
                    groups: !props.orderId,
                    allowHidingColumns: false,
                }), true) }))] }));
}
exports.default = IRTable;
